<template>
    <!-- 하다희 신규 - 근무스케쥴 큰 팝업 -->
    <div class="pop_full" v-if="isShow">
        <div class="layout_wrap schedule">
            <div class="content_wrap">
                <div class="header_title">
                    <span class="m_title">{{ popupTitle }}</span>
                    <a class="close mgl_auto" @click.stop="action_ClosePopup()">
                        <v-icon>mdi-close</v-icon>
                        {{ $t('common.close') }}
                    </a>
                </div>
                <div class="cc">
                    <!-- Left DateSheet -->
                    <DateSheet ref="DataSheet" @openShowWorkCodeSetting="action_ShowWorkCodeSetting" />
                    <!-- Worker List -->
                    <WorkerList />
                </div>
            </div>
        </div>
        <!-- 부서/근무자 설정 -->
        <WorkerSetting :isShow="isShowWorkerSetting" @closeWorkerSetting="closeWorkerSetting" />

        <!-- 근무코드 설정 -->
        <WorkCodeSetting :isShow="isShowWorkCodeSetting" @closeWorkCodeSetting="closeWorkCodeSetting" />
    </div>
</template>

<script>
import DateSheet from './Components/DateSheet/DateSheet.vue'
import WorkerList from './Components/WorkerList/WorkerList.vue'
import WorkerSetting from './Popups/WorkerSetting.vue'
import WorkCodeSetting from './Popups/WorkCodeSetting/WorkCodeSetting.vue'

import { closeWorkStatePopup, sheetOverlays } from '../../../sheet-overlays'
import { workerState, setModifyMode, showWorkerSetting, closeWorkerSetting, showWorkCodeSetting, closeWorkCodeSetting } from './worker-state'


export default {
    components: {
        DateSheet,
        WorkerList,
        WorkerSetting,
        WorkCodeSetting
    },
    data() {
        return {
            sheetOverlays,
            worker: workerState,
        }
    },
    watch: {
        isShow: {
            handler: function (newValue) {
                this.unregistSaveAlert()
                if (newValue == false) { return }
                this.registSaveAlert()
                setModifyMode(undefined)
                this.worker.calendarEditLayer_Date = undefined
                this.worker.isShowWorkerSetting = false
                this.worker.isShowWorkCodeSetting = false
                this.worker.focusedRecord = undefined
                this.worker.focusedElement = undefined
                this.worker.searchLayer_Key = undefined
            }
        },
        isModifyMode: {
            handler: function (newValue) {
                if (newValue == true) {
                    this.worker.calendarEditLayer_Date = undefined
                    this.worker.customTimeOverlay_Date = undefined
                }
            }
        }
    },
    computed: {
        isShow: function () {
            return this.sheetOverlays.isShowWorkStatePopup
        },
        popupTitle: function () {
            return this.isModifyMode ? this.$t('work_schedule.top.title_edit') : this.$t('work_schedule.top.title')
        },
        isShowWorkerSetting: function () {
            return this.worker.isShowWorkerSetting
        },
        isShowWorkCodeSetting: function () {
            return this.worker.isShowWorkCodeSetting
        },
        isModifyMode: function () {
            return this.worker.isModifyMode
        },

    },
    mounted() {
        this.worker.originRecords = undefined
        this.worker.modifiedRecords = undefined
        this.worker.oldWorkCodeRecords = undefined
    },
    methods: {
        // MARK: - Actions
        async action_ClosePopup() {
            if (this.isModifyMode) {
                if (this.isModified() == true) {
                    this.$nextTick(() => {
                        this.showSaveAlert()
                    })
                } else {
                    setModifyMode(false)
                }
            } else {
                let isModified = this.isModified()
                if (isModified == true) { this.showSaveAlert(true) }
                else { closeWorkStatePopup() }
            }
        },
        action_ShowWorkerSetting() {
            showWorkerSetting()
        },
        action_ShowWorkCodeSetting() {
            showWorkCodeSetting()
        },

        // MARK: - Emit
        closeWorkerSetting() {
            closeWorkerSetting()
        },
        closeWorkCodeSetting() {
            closeWorkCodeSetting()
        },


        // MARK: - Alerts
        async showSaveAlert(needClose = false) {
            let result = await this.AlertController.showAlert(this, 'ScheduleSaveAlert')
            if (result == 'close') { return }
            setModifyMode(false)
            if (needClose == true) { closeWorkStatePopup() }
        },
        registSaveAlert() {
            this.AlertController.registAlert(this, 'ScheduleSaveAlert', {
                usingCloseButton: true,
                usingAlertTag: true,
                text: '설정한 일정으로 적용할까요?',
                lButtonTitle: '저장 안함',
                rButtonTitle: '저장',
                checksum: this.checkSaveAlert,
                cHandler: this.alertCancelHandler,
                lHandler: this.alertLeftHandler,
                rHandler: this.alertRightHandler,
            })
        },
        unregistSaveAlert() {
            this.AlertController.unregistAlert(this, 'ScheduleSaveAlert')
        },
        checkSaveAlert() {
            return this.isModified() == false
        },
        alertCancelHandler() {},
        alertLeftHandler() {
            this.worker.oldWorkCodeRecords = undefined
            this.worker.needUpdateRecords = true
        },
        async alertRightHandler() {
            let comp = this.$refs.DataSheet?.$refs.ScheduleCalendar
            await comp.updateBatch()
        },

        // MARK: - 
        isModified() {
            let allRecords = this.worker.modifiedRecords
            let keys = Object.keys(allRecords)
            for (let i = 0; i < keys.length; i++) {
                let key = keys[i]
                if (allRecords[key].isModified == true) { return true}
            }
            return false
        }
    }
}
</script>

<style scoped>
@import '../../../CSS/V2ReservationSchedule.css';
</style>
